import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputMask from "react-input-mask";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function StyledTextInputField({
  value,
  setValue,
  valueError,
  setValueError,
  label,
  required,
  fullWidth,
  size,
  id,
  mask,
  disabled,
  shrink,
}) {
  useEffect(() => {
    setValueError("");
  }, [value]);

  const shouldMaskSSN =
    mask && mask.maskPattern && mask.maskPattern === "999-99-9999" && disabled;
  const [isMasked, setIsMasked] = useState(true);

  return (
    <Box sx={{ minWidth: 120 }}>
      {(shouldMaskSSN && !isMasked) || (mask && !shouldMaskSSN) ? (
        <InputMask
          mask={mask.maskPattern}
          value={value}
          maskChar=""
          disabled={disabled}
          onChange={(event) => setValue(mask.maskFormatter(event.target.value))}
          onBlur={() => {
            if (required && value === "") {
              setValueError("This field is required.");
            }
          }}
        >
          {() => (
            <TextField
              disabled={disabled}
              error={valueError}
              id={id}
              label={label}
              helperText={valueError}
              value={!shouldMaskSSN || !isMasked ? value : "XXX-XX-XXXX"}
              size={size}
              InputProps={
                shouldMaskSSN
                  ? {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setIsMasked(true)}
                            onMouseDown={() => setIsMasked(false)}
                            edge="end"
                          >
                            {isMasked ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }
                  : {}
              }
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Montserrat",
                  color: "#262A3D",
                  fontSize: "14px",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#0D47A1",
                },
                "& .MuiOutlinedInput-root.Mui-focused": {
                  "& > fieldset": {
                    borderColor: "#0D47A1",
                    color: "#0D47A1",
                  },
                },
                "& .MuiOutlinedInput-root": {
                  "& > fieldset": {
                    borderColor: "#DADDE1",
                  },
                },
                "& .MuiOutlinedInput-root.Mui-disabled": {
                  "& > fieldset": {
                    borderColor: "#DADDE1",
                  },
                },
                "& > .MuiOutlinedInput-root:not(.Mui-focused):hover": {
                  "& > fieldset": {
                    borderColor: valueError === "" ? "#DADDE1" : "#D32F2F",
                  },
                },
              }}
              required={required}
              fullWidth={fullWidth}
              InputLabelProps={{ shrink: shrink }}
            />
          )}
        </InputMask>
      ) : (
        <TextField
          error={valueError !== ""}
          id={id}
          label={label}
          helperText={valueError}
          value={
            shouldMaskSSN && isMasked
              ? "XXX-XX-".concat(value.substr(value.length - 4))
              : value
          }
          size={size}
          disabled={disabled}
          onChange={(event) => setValue(event.target.value)}
          InputProps={
            shouldMaskSSN
              ? {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setIsMasked(true)}
                        onMouseDown={() => setIsMasked(false)}
                        edge="end"
                      >
                        {isMasked ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              : {}
          }
          sx={{
            "& .MuiInputLabel-root": {
              fontFamily: "Montserrat",
              color: "#262A3D",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#0D47A1",
            },
            "& .MuiOutlinedInput-root.Mui-focused": {
              "& > fieldset": {
                borderColor: "#0D47A1",
                color: "#0D47A1",
              },
            },
            "& .MuiOutlinedInput-root": {
              "& > fieldset": {
                borderColor: "#DADDE1",
              },
            },
            "& .MuiOutlinedInput-root.Mui-disabled": {
              "& > fieldset": {
                borderColor: "#DADDE1",
              },
            },
            "& > .MuiOutlinedInput-root:not(.Mui-focused):hover": {
              "& > fieldset": {
                borderColor: valueError === "" ? "#DADDE1" : "#D32F2F",
              },
            },
          }}
          required={required}
          fullWidth={fullWidth}
          InputLabelProps={{ shrink: shrink }}
        />
      )}
    </Box>
  );
}
export default StyledTextInputField;
